import { render, staticRenderFns } from "./CommonStatTableTwo.vue?vue&type=template&id=5c36c006&scoped=true"
import script from "./CommonStatTableTwo.vue?vue&type=script&lang=js"
export * from "./CommonStatTableTwo.vue?vue&type=script&lang=js"
import style0 from "./CommonStatTableTwo.vue?vue&type=style&index=0&id=5c36c006&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36c006",
  null
  
)

export default component.exports